(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["age-gate"] && !Shopify.designMode) return;
  try {
    (function () {
    var gate = document.getElementById('nexo-age-gate');
    if (!gate) return;

    var confirmButton = document.getElementById('nexo-age-gate-confirm');
    if (confirmButton) {
      confirmButton.addEventListener('click', function () {
        try {
          window.localStorage.setItem('nexo_age_confirmed', 'true');
        } catch (e) {}
        gate.setAttribute('hidden', '');
      });
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
